export const OFFERS_FOR_REQUEST_LIMIT = 10;
